import { createContext, useContext, type ReactNode } from "react";

const SideVideoLayoutContext = createContext(false);

export function SideVideoLayoutProvider({
  active,
  children,
}: {
  active: boolean;
  children: ReactNode;
}) {
  return (
    <SideVideoLayoutContext.Provider value={active}>
      {active ? (
        <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden">{children}</div>
      ) : (
        children
      )}
    </SideVideoLayoutContext.Provider>
  );
}

export function useSideVideoLayout() {
  return useContext(SideVideoLayoutContext);
}
